import useWindowsSize from "@/Hooks/useWindowsSize";
import type React from "react";
import { useState, type ChangeEvent } from "react";
import { Link } from "react-router-dom";

type Props = {
  onClickFilter: () => void;
  onChanges: (value: number) => void;
  isFilter: boolean;
  estado: boolean;
  onClickState: (value: boolean) => void;
};

export const HeaderFilterPlpMovil = ({
  onClickFilter,
  onChanges,
  onClickState,
  isFilter,
  estado,
}: Props): JSX.Element => {
  const { width } = useWindowsSize();

  const handleOnchange = (e: ChangeEvent<HTMLSelectElement>) => {
    onChanges(Number(e.target.value));
  };

  const movilMax500 = () => (
    <>
      <div className="d-flex align-items-center">
        <div className="p-1">
          <button className="ps-shop__filter-mb" onClick={onClickFilter}>
            <i className="icon-equalizer"></i>
            <span>Filtrar</span>
          </button>
        </div>
        <div className="p-1">
          <div className="header__sort">
            <i className="icon-sort-amount-desc"></i>
            <select className="ps-select" onChange={handleOnchange}>
              <option value="0">Ordenar por</option>
              <option value="1">Precio: mayor a menor</option>
              <option value="2">Precio: menor a mayor</option>
              <option value="3">Mayor calificación</option>
            </select>
          </div>
        </div>
      </div>
      <div className="p-1">
        <div className="d-flex justify-content-end">
          <div className="p-1 align-content-center">
            <p
              className="develop__fontFamilys__titles develop___Color_SalePrice__dark"
              style={{ margin: "0 auto", marginRight: "1rem" }}>
              Vista
            </p>
          </div>
          <div className="p-2 align-content-center">
            <Link to="#" onClick={() => onClickState(true)}>
              <i
                className={estado ? "icon-grid iconActivo" : "icon-grid"}
                style={{ fontSize: 24 }}></i>
            </Link>
          </div>
          <div className="p-2 align-content-center">
            <Link to="#" onClick={() => onClickState(false)}>
              <i
                className={!estado ? "icon-list4 iconActivo" : "icon-list4"}
                style={{ fontSize: 24 }}></i>
            </Link>
          </div>
        </div>
      </div>
    </>
  );

  const movilMin500 = () => (
    <>
      <button className="ps-shop__filter-mb" onClick={onClickFilter}>
        <i className="icon-equalizer"></i>
        {width >= 420 ? <span>Filtrar</span> : ""}
      </button>
      <div className="header__sort">
        <i className="icon-sort-amount-desc"></i>
        <select className="ps-select" onChange={handleOnchange}>
          <option value="0">Ordenar por</option>
          <option value="1">Precio: mayor a menor</option>
          <option value="2">Precio: menor a mayor</option>
          <option value="3">Mayor calificación</option>
        </select>
      </div>
      <div className="text-right">
        <span className="mr-3" onClick={() => onClickState(true)}>
          <i
            className={estado ? "icon-grid iconActivo" : "icon-grid"}
            style={{ fontSize: 24 }}></i>
        </span>
        <span onClick={() => onClickState(false)}>
          <i
            className={!estado ? "icon-list4 iconActivo" : "icon-list4"}
            style={{ fontSize: 24 }}></i>
        </span>
      </div>
    </>
  );

  return (
    <div className={`header__filter ${isFilter ? "main-content active" : ""} `}>
      {width < 500 ? movilMin500() : movilMax500()}
    </div>
  );
};
